<template>
    <div>
        <div class="form-group row mt-4">
            <input type="hidden" :value="ValidateMercancias">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <label class="col-form-label"><em>Los campos marcados con un * son obligatorios</em></label>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-4">
                        <label for="PesoBrutoTotal" class="form-label">Peso Bruto Total*</label>
                        <input v-model="ObjMercancias.PesoBrutoTotal" name="PesoBrutoTotal" id="PesoBrutoTotal" type="text" class="form-control" readonly>
                        <Cvalidation v-if="this.errorvalidacion.PesoBrutoTotal" :Mensaje="'*' + errorvalidacion.PesoBrutoTotal[0]" />
                    </div>

                    <div class="col-12 col-sm-12 col-md-3 col-lg-4">
                        <label for="UnidadPeso" class="form-label">Unidad Peso*</label>
                        <select name="UnidadPeso" id="UnidadPeso" class="form-control form-select"
                            v-model="ObjMercancias.UnidadPeso">
                            <option value="">Seleccione una opción</option>
                            <option v-for="(elem, index) in DataInicial.claveunidadpeso" :key="index" :value="elem.Clave">
                                {{ elem.Clave }} - {{ elem.Nombre }}
                            </option>
                        </select>
                        <Cvalidation v-if="this.errorvalidacion.UnidadPeso" :Mensaje="'*' + errorvalidacion.UnidadPeso[0]" />
                    </div>

                    <div class="col-12 col-sm-12 col-md-3 col-lg-4 mb-4">
                        <label for="NumTotalMercancias" class="form-label">N° Total de Mercancias*</label>
                        <input v-model="ObjMercancias.NumTotalMercancias" name="NumTotalMercancias" id="NumTotalMercancias" type="text" class="form-control" readonly>
                        <Cvalidation v-if="this.errorvalidacion.NumTotalMercancias" :Mensaje="'*' + errorvalidacion.NumTotalMercancias[0]" />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <h5><b>Mercancias</b></h5>
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <button type="button" @click="AgregarMercancia()" v-b-tooltip.hover.Top title="Agregar Mercancia" class="btn btn-primary">
                                    <i class="fa fa-plus-circle"></i>Agregar
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                        <div v-show="ListaMercancias.length">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a v-for="(mercancia, index) in ListaMercancias" class="nav-link"
                                        :class="{ 'active': mercancia.Active, 'text-secondary': !mercancia.Active }"
                                        :key="index" @click="ManageTabs(ListaMercancias, index)" style="cursor: pointer;">
                                        Mercancia {{ index + 1 }}
                                    </a>
                                </div>
                            </nav>
                            <div class="tab-content">
                                <div v-for="(mercancia, index2) in ListaMercancias" class="tab-pane fade"
                                    :class="{ 'show active': mercancia.Active }" :key="index2">
                                    <div class="container-tab">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 my-3 text-end">
                                            <button type="button" @click="BorrarMercancia(index2)" class="btn btn-danger"><i
                                                    class="fas fa-trash"></i></button>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'BienesTransp' + index2" class="form-label">Bienes
                                                    Transportados*</label>
                                                <select :name="'BienesTransp' + index2" :id="'BienesTransp' + index2"
                                                    v-model="mercancia.BienesTransp" class="form-control form-select">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(item, index3) in DataInicial.productoservicio"
                                                        :key="index3" :value="item.Clave">
                                                        {{ item.Clave }} - {{ item.Nombre }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Cantidad' + index2" class="form-label">Cantidad*</label>
                                                <input :name="'Cantidad' + index2" :id="'Cantidad' + index2" type="text"
                                                    @input="$onlyNums($event, mercancia, 'Cantidad')" class="form-control"
                                                    v-model="mercancia.Cantidad">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'ClaveUnidad' + index2" class="form-label">Clave
                                                    Unidad*</label>
                                                <select :name="'ClaveUnidad' + index2" :id="'ClaveUnidad' + index2"
                                                    v-model="mercancia.ClaveUnidad" class="form-control form-select">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(item, index3) in DataInicial.unidadmedida" :key="index3"
                                                        :value="item.Clave">
                                                        {{ item.Clave }} - {{ item.Nombre }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'PesoEnKg' + index2" class="form-label">Peso En Kgs*</label>
                                                <input :name="'PesoEnKg' + index2" :id="'PesoEnKg' + index2"
                                                    class="form-control" v-model="mercancia.PesoEnKg"
                                                    @input="$number_decimal($event, mercancia, 'PesoEnKg'); CalcPesoBrutoTotal();">
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Descripcion' + index2" class="form-label">Descripcion*</label>
                                                <textarea :name="'Descripcion' + index2" :id="'Descripcion' + index2"
                                                    v-model="mercancia.Descripcion" class="form-control" rows="2"
                                                    maxlength="1000"></textarea>
                                            </div>
                                            
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'ValorMercancia' + index2" class="form-label">Valor Mercancia</label>
                                                <input :name="'ValorMercancia' + index2" :id="'ValorMercancia' + index2"
                                                    type="text" v-model="mercancia.ValorMercancia"
                                                    @input="$number_decimal($event, mercancia, 'ValorMercancia')"
                                                    class="form-control">
                                            </div>

                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Moneda' + index2" class="form-label">Moneda</label>
                                                <select :name="'Moneda' + index2" :id="'Moneda' + index2"
                                                    v-model="mercancia.Moneda" class="form-control form-select">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(item, index3) in DataInicial.moneda" :key="index3"
                                                        :value="item.Clave">
                                                        {{ item.Clave }} - {{ item.Nombre }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Dimensiones' + index2" class="form-label">Dimensiones: 0/0/0plg ó cm</label>
                                                <input :name="'Dimensiones' + index2" :id="'Dimensiones' + index2"
                                                    type="text" v-model="mercancia.Dimensiones" class="form-control">
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'MaterialPeligroso' + index2" class="form-label">¿Transporta
                                                    Material Peligroso?*</label>
                                                <select :name="'MaterialPeligroso' + index2"
                                                    :id="'MaterialPeligroso' + index2" @change="HabilitarMatPel(mercancia)"
                                                    class="form-control form-select" v-model="mercancia.MaterialPeligroso">
                                                    <option value="">Seleccione una opción</option>
                                                    <option value="Si">SI</option>
                                                    <option value="No">NO</option>
                                                </select>
                                            </div>

                                            <div v-if="mercancia.MaterialPeligroso === 'Si'"
                                                class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'CveMaterialPeligroso' + index2" class="form-label">Clave
                                                    Material Peligroso</label>
                                                <select :name="'CveMaterialPeligroso' + index2"
                                                    :id="'CveMaterialPeligroso' + index2" class="form-control form-select"
                                                    v-model="mercancia.CveMaterialPeligroso">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(item, index3) in DataInicial.materialpeligroso"
                                                        :key="index3" :value="item.Clave">
                                                        {{ item.Clave }} - {{ item.Descripcion }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div v-if="mercancia.MaterialPeligroso === 'Si'"
                                                class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Embalaje' + index2" class="form-label">Embalaje</label>
                                                <select :name="'Embalaje' + index2" :id="'Embalaje' + index2"
                                                    class="form-control form-select" v-model="mercancia.Embalaje" @change="setDescripcionEmb(mercancia)">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(item, index3) in DataInicial.embalaje" :key="index3"
                                                        :value="item.Clave">
                                                        {{ item.Clave }} - {{ item.Descripcion }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div v-if="mercancia.MaterialPeligroso === 'Si'" class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <div id="ClavMat3_'">
                                                    <label class="col-form-label">Descripción Embalaje</label>
                                                    <textarea v-model="mercancia.DescripEmbalaje" :id="'DescripEmbalaje'+ index2" :name="'DescripEmbalaje'+ index2" class="form-control" rows="4" readonly></textarea>
                                                </div>
                                            </div> 

                                            <div v-show="ObjMercancias.Fraccion" class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'Fraccion' + index2" class="form-label">Fracción
                                                    Arancelaria</label>
                                                <input :name="'Fraccion' + index2" :id="'Fraccion' + index2" type="text"
                                                    class="form-control" v-model="mercancia.FraccionArancelaria">
                                            </div>
                                        </div>
                                        <!-- 
                                        <div v-show="ObjMercancias.HabPedimentos" class="form-group row align-items-end">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-5">
                                                <div class="form-group row">
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <h4>Pedimentos</h4>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <button @click="AgregarPedimento(mercancia)" class="btn btn-info ms-3"
                                                        v-b-tooltip.hover.Top title="Agregar pedimento"><i
                                                            class="fa fa-plus-circle"></i> Agregar</button>
                                                    </div>
                                                </div>
                                                <div v-for="(pedimento, indexPed) in mercancia.ArrayPedimentos" :key="indexPed"
                                                    class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                                                    <div class="row align-items-end">
                                                        <div :for="'' + index2 + '_' + indexPed"
                                                            class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4">
                                                            <label class="form-label">Pedimento*</label>
                                                            <input type="text" class="form-control"
                                                                v-model="pedimento.Pedimento">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                            <button @click="BorrarPedimento(mercancia, indexPed)"
                                                                class="btn btn-danger mb-0" v-b-tooltip.hover.Top
                                                                title="Borrar pedimento"><i class="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-group row align-items-end">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5">
                                                <div class="form-group row">
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <h4>Guías de Identificación</h4>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <button @click="AgregarGuiaI(mercancia)" class="btn btn-info ms-3"
                                                            title="Agregar guía"><i
                                                                class="fa fa-plus-circle"></i> Agregar</button>
                                                    </div>
                                                </div>
                                                <div v-for="(guiaI, indexGI) in mercancia.ArrayGuias" :key="indexGI"
                                                    class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                                                    <div class="row align-items-end">
                                                        <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                            <label :for="'NumeroGuiaIdentificacion' + index2 + '_' + indexGI"
                                                                class="form-label">Numero
                                                                Guia Identificación*</label>
                                                            <input :name="'NumeroGuiaIdentificacion' + index2 + '_' + indexGI" :id="'NumeroGuiaIdentificacion' + index2 + '_' + indexGI" type="text" class="form-control"
                                                                v-model="guiaI.NumeroGuiaIdentificacion">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                            <label :for="'PesoGuiaIdentificacion' + index2 + '_' + indexGI"
                                                                class="form-label">Peso Guia
                                                                Identificación*</label>
                                                            <input :name="'PesoGuiaIdentificacion' + index2 + '_' + indexGI" :id="'PesoGuiaIdentificacion' + index2 + '_' + indexGI" type="text" class="form-control"
                                                                    @input="$number_decimal($event, guiaI, 'PesoGuiaIdentificacion')" v-model="guiaI.PesoGuiaIdentificacion">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-5 col-lg-5 ">
                                                            <label :for="'DescripGuiaIdentificacion' + index2 + '_' + indexGI"
                                                                class="form-label">Descripción Guia
                                                                Identificación*</label>
                                                            <textarea :name="'DescripGuiaIdentificacion' + index2 + '_' + indexGI" :id="'DescripGuiaIdentificacion' + index2 + '_' + indexGI" v-model="guiaI.DescripGuiaIdentificacion"
                                                                class="form-control" rows="2" maxlength="1000"></textarea>
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                            <button @click="BorrarGuiaI(mercancia, indexGI)"
                                                                class="btn btn-danger mb-0" v-b-tooltip.hover.Top
                                                                title="Borrar guía"><i class="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row align-items-end">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5">
                                                <div class="form-group row">
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <h4>Cantidad Transporta</h4>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <button @click="AgregarCantidadT(mercancia)" class="btn btn-info ms-3"
                                                            title="Agregar cantidad transporta"><i
                                                                class="fa fa-plus-circle"></i> Agregar</button>
                                                    </div>
                                                </div>
                                                <div v-for="(cantTransp, indexCT) in mercancia.ArrayCantTrans"
                                                    :key="indexCT" class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                                                    <div class="row align-items-end">
                                                        <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                            <label :for="'CantidadM' + index2 + '_' + indexCT"
                                                                class="form-label">Cantidad*</label>
                                                            <input :name="'CantidadM' + index2 + '_' + indexCT" :id="'CantidadM' + index2 + '_' + indexCT" type="text" class="form-control" @input="$onlyNums($event, cantTransp, 'CantidadM')"
                                                                v-model="cantTransp.CantidadM">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                            <label :for="'IDOrigen' + index2 + '_' + indexCT"
                                                                class="form-label">IDOrigen*</label>
                                                            <input :name="'IDOrigen' + index2 + '_' + indexCT" :id="'IDOrigen' + index2 + '_' + indexCT" type="text" class="form-control"
                                                                v-model="cantTransp.IDOrigen" maxlength="8">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                            <label :for="'IDDestino' + index2 + '_' + indexCT"
                                                                class="form-label">IDDestino*</label>
                                                            <input :name="'IDDestino' + index2 + '_' + indexCT" :id="'IDDestino' + index2 + '_' + indexCT" type="text" class="form-control"
                                                                v-model="cantTransp.IDDestino" maxlength="8">
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                            <button @click="BorrarCantidadT(mercancia, indexCT)"
                                                                class="btn btn-danger mb-0" v-b-tooltip.hover.Top
                                                                title="Borrar cantidad transporta"><i
                                                                    class="fa fa-trash"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="horizontal dark my-2">
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="d-flex align-items-center">
                            <h5><b>Configuración Vehicular</b></h5>
                            <div v-if="false">
                                <div class="d-flex align-items-center">
                                    <b-form-checkbox @change="HabilitarAF()" class="ms-3 me-1" switch
                                        v-model="Autotransporte.HabilitaAF">
                                        <b v-if="Autotransporte.HabilitaAF">Habilitado</b>
                                        <b v-else>Deshabilitado</b>
                                    </b-form-checkbox>
                                    <i id="infoAutotransporte" class="fal fa-info-circle cursor-info" v-b-tooltip.hover.Top
                                        title="Si se habilita, los campos marcados con * se vuelven obligatorios"></i>
                                </div>
                                <Cvalidation v-if="this.errorvalidacion.HabilitaAutoTransporte"
                                    :Mensaje="'*' + errorvalidacion.HabilitaAutoTransporte[0]" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 mb-3">
                        <!-- IDENTIFICACION VEHICULAR -->
                        <div class="mb-5">
                            <h6>Identificación Vehicular</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="PlacaVM" class="form-label">Placa VM*</label>
                                    <div class="input-group">
                                        <input name="PlacaVM" id="PlacaVM" type="text" @input="AutocompPlacaVM();"
                                            class="form-control ps-2" v-model="Autotransporte.PlacaVM" :readonly="!Autotransporte.HabilitaAF">
                                        <button type="button" @click="AutocompPlacaVM()"
                                            class="btn btn-outline-primary mb-0">
                                            <i :class="IconSearch"></i>
                                        </button>
                                    </div>
                                    <Cvalidation v-if="this.errorvalidacion.PlacaVM" :Mensaje="'*' + errorvalidacion.PlacaVM[0]" />

                                    <div class="position-relative">
                                        <ul class="busqueda list-group">
                                            <li v-for="(elem, index) in AutocompPlacaList" :key="index"
                                                @click="SetDataVehic(elem.IdVehiculo)" class="bss list-group-item">
                                                <i class="fa fa-truck"></i> {{ elem.Placa }} / {{ elem.NoEconomico }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="Clave" class="form-label">Configuración Vehicular*</label>
                                    <select class="form-control form-select" :disabled="!Autotransporte.HabilitaAF"
                                        name="Clave" id="Clave" v-model="Autotransporte.ConfigVehicular"
                                        @change="ValidarSelect('config'); ValidarConfigVehRem()">
                                        <option value="">Seleccione una opcion</option>
                                        <option v-for="(elem,index) in DataInicial.configvehicular" :key="index" :value="elem.Clave">
                                            {{ elem.Clave }} - {{ elem.Nombre }}
                                        </option>
                                    </select>
                                    <Cvalidation v-if="this.errorvalidacion.ConfigVehicular" :Mensaje="'*' + errorvalidacion.ConfigVehicular[0]" />
                                </div>

                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                    <label for="AnioModeloVM" class="form-label">Año Modelo VM*</label>
                                    <input type="text" v-model="Autotransporte.AnioModeloVM" @input="$onlyNums($event, Autotransporte, 'AnioModeloVM')" name="AnioModeloVM" id="AnioModeloVM" class="form-control" :readonly="!Autotransporte.HabilitaAF">
                                    <Cvalidation v-if="this.errorvalidacion.AnioModeloVM" :Mensaje="'*' + errorvalidacion.AnioModeloVM[0]" />
                                </div>

                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                    <label for="PesoBrutoVehicular" class="form-label">Peso Bruto Vehicular (en toneladas)*</label>
                                    <input type="text" v-model="Autotransporte.PesoBrutoVehicular" @input="$onlyNums($event, Autotransporte, 'PesoBrutoVehicular')" name="PesoBrutoVehicular" id="PesoBrutoVehicular" class="form-control" :readonly="!Autotransporte.HabilitaAF" >
                                    <Cvalidation v-if="this.errorvalidacion.PesoBrutoVehicular" :Mensaje="'*' + errorvalidacion.PesoBrutoVehicular[0]" />
                                </div>
                            </div>
                        </div>

                        <!-- SCT -->
                        <div class="mb-5">
                            <h6>SCT</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="PermSCT" class="form-label">Permiso SCT*</label>
                                    <select v-model="Autotransporte.PermSCT" @change="ValidarSelect('perm');" name="PermSCT" id="PermSCT" class="form-control form-select" :disabled="!Autotransporte.HabilitaAF">
                                        <option value="">Seleccione una opción</option>
                                        <option v-for="(elem, index) in DataInicial.permisosct" :key="index"
                                            :value="elem.Clave">
                                            {{ elem.Clave }} - {{ elem.Descripcion }}
                                        </option>
                                    </select>
                                    <Cvalidation v-if="this.errorvalidacion.PermSCT" :Mensaje="'*' + errorvalidacion.PermSCT[0]" />
                                </div>

                                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <label for="NumPermisoSCT" class="form-label">Número Permiso SCT*</label>
                                    <input type="text" v-model="Autotransporte.NumPermisoSCT" name="NumPermisoSCT" id="NumPermisoSCT" class="form-control" :readonly="!Autotransporte.HabilitaAF" maxlength="50">
                                    <Cvalidation v-if="this.errorvalidacion.NumPermisoSCT" :Mensaje="'*' + errorvalidacion.NumPermisoSCT[0]" />
                                </div>
                            </div>
                        </div>

                        <!-- SEGUROS -->
                        <div class="mb-5">
                            <h6>Seguros</h6>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="AseguraRespCivil" class="form-label">Nombre Aseguradora*</label>
                                    <input type="text" v-model="Autotransporte.AseguraRespCivil" name="AseguraRespCivil" id="AseguraRespCivil" :readonly="!Autotransporte.HabilitaAF" class="form-control" maxlength="50">
                                    <Cvalidation v-if="this.errorvalidacion.AseguraRespCivil" :Mensaje="'*' + errorvalidacion.AseguraRespCivil[0]" />
                                </div>

                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="PolizaRespCivil" class="form-label">N° Poliza Aseguradora*</label>
                                    <input type="text" v-model="Autotransporte.PolizaRespCivil" name="PolizaRespCivil" id="PolizaRespCivil"  :readonly="!Autotransporte.HabilitaAF" class="form-control" maxlength="50">
                                    <Cvalidation v-if="this.errorvalidacion.PolizaRespCivil" :Mensaje="'*' + errorvalidacion.PolizaRespCivil[0]" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="AseguraMedAmbiente" class="form-label">Asegura Medio Ambiente</label>
                                    <input type="text" v-model="Autotransporte.AseguraMedAmbiente" name="AseguraMedAmbiente" id="AseguraMedAmbiente" :readonly="!ObjMercancias.TranspMatPelig||!Autotransporte.HabilitaAF " class="form-control" maxlength="30">
                                    <Cvalidation v-if="this.errorvalidacion.AseguraMedAmbiente" :Mensaje="'*' + errorvalidacion.AseguraMedAmbiente[0]" />
                                </div>

                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="PolizaMedAmbiente" class="form-label">Poliza Medio Ambiente</label>
                                    <input type="text" v-model="Autotransporte.PolizaMedAmbiente" name="PolizaMedAmbiente" id="PolizaMedAmbiente" :readonly="!ObjMercancias.TranspMatPelig||!Autotransporte.HabilitaAF" class="form-control" maxlength="30">
                                    <Cvalidation v-if="this.errorvalidacion.PolizaMedAmbiente" :Mensaje="'*' + errorvalidacion.PolizaMedAmbiente[0]" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="AseguraCarga" class="form-label">Aseguradora Carga</label>
                                    <input name="AseguraCarga" id="AseguraCarga" type="text" class="form-control"
                                        v-model="Autotransporte.AseguraCarga" maxlength="30"
                                        :readonly="!Autotransporte.HabilitaAF">
                                </div>

                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label for="PolizaCarga" class="form-label">Póliza Carga</label>
                                    <input name="PolizaCarga" id="PolizaCarga" type="text" class="form-control"
                                        v-model="Autotransporte.PolizaCarga" maxlength="30"
                                        :readonly="!Autotransporte.HabilitaAF">
                                </div>
                            </div>
                        </div>

                        <!-- REMOLQUES -->
                        <div>
                            <div class="form-group row">
                                <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                    <h6>Remolques</h6>
                                </div>

                                <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                    <button type="button" @click="AgregarRemolque()" v-b-tooltip.hover.Top
                                        title="Agregar Remolque (Max. 2)" class="btn btn-primary"
                                        :disabled="!Autotransporte.HabilitaAF"><i class="fa fa-plus-circle"></i>
                                        Agregar</button>
                                </div>
                            </div>

                            <div v-for="(remolque, index) in ArrRemolques" :key="index" class="form-group row align-items-end"
                                id="FilaRem_1">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                    <label :for="'SubtipoRem_' + index" class="form-label">SubTipo Remolque*</label>
                                    <select :name="'SubtipoRem_' + index" :id="'SubtipoRem_' + index"
                                        class="form-control form-select" v-model="remolque.SubTipoRem">
                                        <option value="">Seleccione una opción</option>
                                        <option v-for="(elem, id2) in DataInicial.remolques" :key="id2" :value="elem.Clave">
                                            {{ elem.Clave }} - {{ elem.Nombre }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                                    <label :for="'PlacaRem_' + index" class="form-label">Placa*</label>
                                    <input :name="'PlacaRem_' + index" :id="'PlacaRem_' + index" type="text"
                                        class="form-control" v-model="remolque.Placa">
                                </div>

                                <div class="col-12 col-sm-12 col-md-3 col-lg-2 mt-2 text-left">
                                    <button type="button" @click="BorrarRemolque(index)" class="btn btn-danger mb-0"><i
                                            class="fa fa-trash"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Configs from '@/helpers/VarConfig.js';
const SPINNER = 'spinner-border spinner-border-sm';
const MAGNIFIER = 'fa fa-search';
const EmitEjecuta = 'seccionMercancias';

export default {
    name: 'FormMercancias',
    props: ['DataInicial', 'pObjMercancias', 'pAutotransporte', 'poBtnSave', 'pErrorvalidacion', 'pListaMercancias'],
    components: {},
    data() {
        return {
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'routerhaciaatras',
                EmitSeccion: EmitEjecuta,
            },
            ObjMercancias: {
                PesoBrutoTotal: '',
                UnidadPeso: '',
                NumTotalMercancias: '',
                // Helpers
                Fraccion: '',
                TranspMatPelig:false,
                HabPedimentos: '',
            },
            ObjMerc: {
                IdMercancia: 0,
                BienesTransp: '',
                Descripcion: '',
                Cantidad: '',
                ClaveUnidad: '',
                PesoEnKg: '',
                MaterialPeligroso: '',
                CveMaterialPeligroso: '',
                Embalaje: '',
                DescripEmbalaje: '',
                ValorMercancia: '',
                Moneda: '',
                FraccionArancelaria: '',
                ArrayPedimentos: [],
                ArrayGuias: [],
                ArrayCantTrans: [],
                Active: false,
            },
            Autotransporte: {
                IdAutotransporte: '',
                PermiteRemolque: false,
                IdVehiculo: '',
                // Identificacion vehicular
                PlacaVM: '',
                ConfigVehicular: '',
                AnioModeloVM: '',
                PesoBrutoVehicular: '',
                //SCT
                PermSCT: '',
                NumPermisoSCT: '',
                //Seguros
                AseguraRespCivil: '',
                PolizaRespCivil: '',
                AseguraMedAmbiente: '',
                PolizaMedAmbiente: '',
                AseguraCarga: '',
                PolizaCarga: '',
                // helper
                HabilitaAF: true,
            },
            ArrRemolques: [],
            ObjRemolque: {
                SubTipoRem: '',
                Placa: '',
            },
            // Autompletados (Listas)
            AutocompPlacaList: [],
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: false,
            },
            // HELPERS
            ListaMercancias: [],
            ListaMerCanceladas: [],
            // DsblMedAmb: true,
            TimeOutSearch: null,
            IconSearch: MAGNIFIER,
            segurity: {},
            masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            Emit: EmitEjecuta,
        }
    },
    methods:
    {
        // Maneja los estados de los tabs y paneles.
        ManageTabs(List, index) {
            List.forEach((elem, i) => {
                if (i === index) {
                    elem.Active = true;
                } else {
                    elem.Active = false;
                }
            })
        },
        // Habilita o deshabilita los campos para Material peligroso.
        HabilitarMatPel(item) {
            if (item.CveMaterialPeligroso !== 'Si') {
                item.CveMaterialPeligroso = '';
                item.Embalaje = '';
                item.DescripEmbalaje = '';
            }
            this.HabilitarAseguraMatPel();
        },
        // Habilita los campos de aseguradoras.
        HabilitarAseguraMatPel() {
            let ExisteMatPel = this.ListaMercancias.some(elem => elem.MaterialPeligroso === "Si")
            // Setea los valores de Asegura y Poliza a '' si no hay material peligroso en Mercancias
            if (ExisteMatPel && this.Autotransporte.HabilitaAF) {
                this.ObjMercancias.TranspMatPelig = true;
            } else {
                this.Autotransporte.AseguraMedAmbiente = '';
                this.Autotransporte.PolizaMedAmbiente = '';
                this.ObjMercancias.TranspMatPelig = false;
            }
        },
        // Habilita el campo de fracción arancelaria.
        ActualizarFraccion() {
            if (!this.ObjMercancias.Fraccion) {
                this.ListaMercancias.forEach(elem => elem.FraccionArancelaria = '')
            }
        },
        // Elimina ArrayPedimentos de todas las mercancias (Documento: TipoMercancia!== 'Entrada')
        ActualizarPedimentos() {
            if (!this.ObjMercancias.HabPedimentos) {
                this.ListaMercancias.forEach(elem => elem.ArrayPedimentos = [])
            }
        },
        // Autocompletado para placa de configuración vehicular.
        AutocompPlacaVM() {
            clearTimeout(this.TimeOutSearch);
            this.TimeOutSearch = setTimeout(() => {
                this.BuscarPlacaVM();
            }, 750);
        },
        // Recupera la lista de placas coincidientes con la busqueda.
        BuscarPlacaVM() {
            const MINLENGTH = 0;
            const KEYWORD = this.Autotransporte.PlacaVM;

            if (KEYWORD.length > MINLENGTH) {
                this.IconSearch = SPINNER;
                this.$http.get('cpVehiculosAutocomp/', {
                    params:{
                        TxtBusqueda:KEYWORD
                    }
                }
                ).then((res) => {
                    this.AutocompPlacaList = res.data.data;
                }).finally(() => {
                    this.IconSearch = MAGNIFIER;
                })
            } else {
                // ???
                this.Autotransporte.IdVehiculo = 0;
                this.AutocompPlacaList = []
            }
        },
        // Rellena el objeto Autotransporte con la data recuperada.
        SetDataVehic(Id) {
            if(!this.Autotransporte.HabilitaAF){
                this.AutocompPlacaList = [];
                return false;
            }
            this.$http.get('cpVehiculos/' + Id,
            ).then((res) => {
                let resp = res.data.data;
                this.Autotransporte.IdVehiculo = resp.IdVehiculo;
                this.Autotransporte.PermSCT = resp.PermisoSCT;
                this.Autotransporte.NumPermisoSCT = resp.NumPermisoSCT;
                this.Autotransporte.ConfigVehicular = resp.ConfigVehicular;
                this.Autotransporte.PlacaVM = resp.Placa;
                this.Autotransporte.AnioModeloVM = resp.Modelo;
                this.Autotransporte.AseguraRespCivil = resp.Aseguradora;
                this.Autotransporte.PolizaRespCivil = resp.Poliza;

                // Validamos configVeh para conservar o remover remolques    
                this.ValidarConfigVehRem()
            }).finally(() => this.AutocompPlacaList = [])
        },
        // Agrega un al Arreglo de remolques si se valida la configuración vehicular.
        async AgregarRemolque() {
            if (!this.Autotransporte.ConfigVehicular) {
                this.$toast.error('Primero debe seleccionar una configuración vehicular');
                return false;
            } else if (this.ArrRemolques.length >= 2) {
                this.$swal(Configs.configMaxRemolques);
                return false;
            }
            try {
                let validacion = await this.ValidarConfigVehRem()

                if (validacion) {
                    let newRemolque = { ...this.ObjRemolque }
                    this.ArrRemolques.push(newRemolque)
                } else {
                    this.$swal(Configs.configNoPermRemolques);
                }
            } catch (error) {
                console.error('Error al validar remolque:', error);
            }
        },
        // Valida que la configuración vehicular permita remolques.
        async ValidarConfigVehRem() {
            if (this.Autotransporte.ConfigVehicular) {
                let validacion
                await this.$http.get('/validarConfigVeh/' + this.Autotransporte.ConfigVehicular,).then((res) => {
                    if (res.data.data) {
                        validacion = true;
                    } else {
                        if (this.ArrRemolques.length > 0) {
                            this.$toast.error('Remolques removidos');
                            this.ArrRemolques = [];
                        }
                        validacion = false;
                    }
                    this.Autotransporte.PermiteRemolque = validacion;
                }).catch(err => {
                    this.$toast.error('Configuración vehicular no registrada.');
                    console.error(err);
                });
                return validacion;
            } else {
                // Remuoverá los remolques añadidos si la configuración vehicular no lo permite.
                if (this.ArrRemolques.length > 0) {
                    this.$toast.error('Remolques removidos');
                    this.ArrRemolques = [];
                }
                return false
            }
        },
        // Remueve el remolque de la Arreglo de remolques.
        BorrarRemolque(Index) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    this.ArrRemolques.splice(Index, 1)
                }
            });
        },
        // Agrega una mercancia vacía.
        AgregarMercancia() {
            let isActive = false;
            if (this.ListaMercancias.length <= 0) {
                isActive = true;
            }

            let newObjMercancia = JSON.parse(JSON.stringify(this.ObjMerc))
            newObjMercancia.Active = isActive;

            this.ListaMercancias.push(newObjMercancia);
            this.SetTotalMerc();

        },
        // Borra la mercancia indicada.
        BorrarMercancia(Index) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    // En caso de que la mercancia eliminada ya existiera se prepara para borrarla de la base de datos.
                    if (this.ListaMercancias[Index].IdMercancia > 0) {
                        let MercanciaCancelada = { IdMercancia: this.ListaMercancias[Index].IdMercancia }
                        this.ListaMerCanceladas.push(MercanciaCancelada)
                    }

                    // Elimina el item de ListaMercancias
                    this.ListaMercancias.splice(Index, 1)
                    this.ListaMercancias.forEach(elem => elem.Active = false)

                    // Establece quien sera el tab de Mercancias activo
                    let newIndex = Index;
                    if ((Index === this.ListaMercancias.length) && Index > 0) {
                        newIndex = this.ListaMercancias.length - 1;
                    }
                    if (this.ListaMercancias.length > 0) {
                        this.ListaMercancias[newIndex].Active = true;
                    }

                    // Refresca las variables donde tenga injerencia
                    this.HabilitarAseguraMatPel();
                    this.SetTotalMerc();
                    this.CalcPesoBrutoTotal();
                    this.UpdateHabIdUbicacion();
                }
            });
        },
        // Actualiza el valor de NumTotalMercancias.
        SetTotalMerc() {
            this.ObjMercancias.NumTotalMercancias = this.ListaMercancias.length;
        },
        // Calcula el peso bruto total de las mercancias.
        CalcPesoBrutoTotal() {
            let pesoBrutoTotal = this.ListaMercancias.reduce((acc, item) => {
                let num = parseFloat(item.PesoEnKg)
                num = isNaN(num) ? 0 : num;
                return acc + num;
            }, 0);
            this.ObjMercancias.PesoBrutoTotal = pesoBrutoTotal;
        },
        // Agrega un pedimento vacío.
        AgregarPedimento(ItemMerc) {
            let newPedimento = {
                Pedimento: '',
            }
            ItemMerc.ArrayPedimentos.push(newPedimento)
        },
        // Borra el pedimento indicado.
        BorrarPedimento(ItemMerc, IndexPed) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    ItemMerc.ArrayPedimentos.splice(IndexPed, 1)
                }
            });
        },
        // Agrega una Guía de identificación vacía.
        AgregarGuiaI(ItemMerc) {
            let newGuiaI = {
                NumeroGuiaIdentificacion: '',
                DescripGuiaIdentificacion: '',
                PesoGuiaIdentificacion: '',
            }
            ItemMerc.ArrayGuias.push(newGuiaI)
        },
        // Borra la Guía de identificación indicada.
        BorrarGuiaI(ItemMerc, IndexGI) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    ItemMerc.ArrayGuias.splice(IndexGI, 1)
                }
            });
        },
        // Agrega un Cantidad Transporta vacía.
        AgregarCantidadT(ItemMerc) {
            let newGuiaI = {
                CantidadM: '',
                IDOrigen: '',
                IDDestino: '',
            }
            ItemMerc.ArrayCantTrans.push(newGuiaI)
            this.UpdateHabIdUbicacion();
        },
        // Agrega un Cantidad Transporta vacía.
        BorrarCantidadT(ItemMerc, IndexCT) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    ItemMerc.ArrayCantTrans.splice(IndexCT, 1)
                    this.UpdateHabIdUbicacion();
                }
            });
        },
        // Habilita Auto Federal.
        HabilitarAF() {
            if (!this.Autotransporte.HabilitaAF) {
                this.Autotransporte.PermSCT = '';
                this.Autotransporte.NumPermisoSCT = '';
                this.Autotransporte.ConfigVehicular = '';
                this.Autotransporte.PlacaVM = '';
                this.Autotransporte.AnioModeloVM = '';
                this.Autotransporte.AseguraCarga = '';
                this.Autotransporte.PolizaCarga = '';
                this.Autotransporte.AseguraRespCivil = '';
                this.Autotransporte.PolizaRespCivil = '';
                this.Autotransporte.AseguraMedAmbiente = '';
                this.Autotransporte.PolizaMedAmbiente = '';

                this.ValidarConfigVehRem();

                this.ObjMercancias.PesoBrutoTotal = 0;
                this.bus.$emit('UpdateDistTotal', 0)
                document.getElementById('TotalDistRec').value = 0;
            }
        },
        // Habilita o deshabilita el campo IdUbicación.
        UpdateHabIdUbicacion() {
            // Busca en ListaMercancias si en alguna mercancia hay nodos en Cantidad transporta (para 
            // habilitar o deshabilitar IdUbicacion en Ubicaciones).
            let valor = this.ListaMercancias.some(merc => {
                return merc.ArrayCantTrans.length > 0;
            })
            this.bus.$emit('UpdateHabIdUbicacion', valor)
        },
        // Remueve el atributo solo lectura en Peso y distancia recorrida.
        HabilitarPesoDist() {
            let isHabilitado = true;
            // this.HabilitaPeso = isHabilitado;
            // this.bus.$emit('HabilitarDistRec', isHabilitado);
        },
        // Vacia los select indicados.
        ValidarSelect(Lugar) {
            if (!this.Autotransporte.HabilitaAF) {
                if (Lugar === 'config') {
                    this.Autotransporte.ConfigVehicular = '';
                } else if (Lugar === 'perm') {
                    this.Autotransporte.PermSCT = '';
                }
            }
        },
        // Setea la data recuperada cuando es un recovery de la cartaporte.
        SetearDataRecov() {
            if (this.pObjMercancias != undefined) {
                Object.assign(this.ObjMercancias, this.pObjMercancias);
            }
            if (this.pAutotransporte != undefined) {
                Object.assign(this.Autotransporte, this.pAutotransporte);
            }
            if (this.pAutotransporte.ArrRemolques != undefined) {
                this.ArrRemolques = this.pAutotransporte.ArrRemolques.filter(elem => elem.SubTipoRem);
                this.ValidarConfigVehRem();
            }
            if (this.pListaMercancias.length > 0) {
                this.ListaMercancias = this.pListaMercancias.map((merc, index) => {
                    let newMercancia = JSON.parse(JSON.stringify(this.ObjMerc))
                    Object.assign(newMercancia, merc);
                    newMercancia.Active = index === 0 ? true : false;
                    if (merc.ArrayPedimentos.length > 0) {
                        newMercancia.ArrayPedimentos = merc.ArrayPedimentos.map(elem => {
                            let newPedimento = {
                                Pedimento: elem.Pedimento,
                            }
                            return newPedimento;
                        })
                    }
                    return newMercancia;
                })
                this.ListaMercancias.forEach(elem => {
                    elem.ArrayCantTrans.forEach(elem => {
                        elem.CantidadM = elem.Cantidad;
                    })
                })
            }
            this.UpdateHabIdUbicacion();
            this.HabilitarAseguraMatPel()
            this.SetTotalMerc();
            this.CalcPesoBrutoTotal();
        },
        Limpiar() {
            let Objs = [this.ObjMercancias, this.Autotransporte]
            Objs.forEach(ObjLimp => {
                Object.keys(ObjLimp).forEach(propiedad => {
                    ObjLimp[propiedad] = '';
                });
            })
            this.Autotransporte.HabilitaAF = true;
            this.Autotransporte.PermiteRemolque = false;

            this.ListaMerCanceladas = [];
            this.ListaMercancias = [];
            this.ArrRemolques = [];
            this.AutocompPlacaList = [];
            this.ObjMercancias.TranspMatPelig = false;

            this.errorvalidacion = [];
        },
        setDescripcionEmb(item){
            let Buscar = item.Embalaje;
            let row = this.DataInicial.embalaje.filter(function(element,index){
                if(element.Clave == Buscar){
                    return element;
                }
                else{
                    return '';
                }
            });
            
            if(row[0]){
                item.DescripEmbalaje = row[0].Descripcion;
            }
            else{
                item.DescripEmbalaje = '';
            }
        }
    },
    computed: {
        ValidateMercancias() {
            if (this.pObjMercancias.HabPedimentos != this.ObjMercancias.HabPedimentos) {
                this.ObjMercancias.HabPedimentos = this.pObjMercancias.HabPedimentos;
                this.ActualizarPedimentos();
            }
            if (this.pObjMercancias.Fraccion != this.ObjMercancias.Fraccion) {
                this.ObjMercancias.Fraccion = this.pObjMercancias.Fraccion;
                this.ActualizarFraccion();
            }
            if (this.pListaMercancias.length >= 1) {
                this.ListaMercancias = this.pListaMercancias.map(elem => {
                    let objMerc = JSON.parse(JSON.stringify(this.ObjMerc));
                    Object.assign(objMerc, elem);
                    return objMerc;
                });
                this.ListaMercancias[0].Active = true;
                this.bus.$emit('LimpiarMercProp');
                this.HabilitarAseguraMatPel();
                this.SetTotalMerc();
            }
            if (this.pErrorvalidacion != undefined) {
                this.errorvalidacion = this.pErrorvalidacion;
            }
            return ''
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.SetearDataRecov();
    }
}
</script>
<style>#infoAutotransporte {
    cursor: help;
}</style>